module.exports = __webpack_public_path__ + "img/a70043c.jpg";